import React, { FC } from 'react';
import './styles.scss';

export const Skeleton: FC = () => {
  return (
    <div className="talent-carrousel-header-skeleton">
      <div className="talent-carrousel-header-skeleton__skeleton-name pulse-fade" />
      <div className="talent-carrousel-header-skeleton__skeleton-right-section pulse-fade">
        <div className="talent-carrousel-header-skeleton__skeleton-state" />
        <div className="talent-carrousel-header-skeleton__skeleton-button" />
        <div className="talent-carrousel-header-skeleton__skeleton-options" />
      </div>
    </div>
  );
};
